<template>
  <div class="eachars-box bott">
     <div class="daterange">
        <el-date-picker
          @change="formChange"
          v-model="categoryTime"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button class="button" size="mini" type="primary" @click="exportInputAnalysis">导出</el-button>
      </div>
    <div id="categoryData" :style="{width: '100%', height: '320px'}"></div>
  </div>
</template>
<script>
import { getCategoryCount } from '@/resource/api/dataAnalysis'
export default {
  props: ['todayOptions'],
  data () {
    return {
      exportApp: '',
      categoryTime: [],
      defaultDate: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000),
        new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
      ],
      pickerOptions: {
        disabledDate: (time) => {
          // 不可选中180天前日期
          return this.dealDisabledDate(time)
        }
      },
      form: {
        startTime: '',
        endTime: '',
        createBy: this.$store.state.router.createBySuffix,
        platform: this.$store.state.router.cpcode
      },
      echartBox: null
    }
  },
  mounted () {
    this.pageInit() // 初始化数据
  },
  methods: {
    pageInit () {
      this.form.startTime = this.$moment(this.defaultDate[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.endTime = this.$moment(this.defaultDate[1]).format('YYYY-MM-DD HH:mm:ss')
      this.categoryTime = [this.form.startTime, this.form.endTime]
      this.categoryProgram() // 节目及节目集分类统计
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = timeArr[0]
        this.form.endTime = timeArr[1]
        this.getData()
      }
    },
    dealDisabledDate (time) {
      const today = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
      if (new Date(time).getTime() > today) {
        return time.getTime() >= today // 时间范围必须是时间戳
      } else {
        return time.getTime() < Date.now() - 180 * 8.64e7 // 8.64e7就是一天的时间戳 24*60*60*1000 180天前不可选
      }
    },
    getData () {
      const that = this
      // 绘制图表
      getCategoryCount(that.form).then((res) => {
        if (res && res.code == 1) {
          if (res.result.xAxis.data.length == 0) {
            that.echartBox.showLoading({
              text: '暂无数据',
              color: '#ffffff',
              fontSize: 16,
              showSpinner: false,
              textColor: '#8a8e91',
              maskColor: 'rgba(255, 255, 255, 0)'
            })
            const setDataOptin = {
              xAxis: [
                { data: [] }
              ],
              series: [
                { data: [] },
                { data: [] }
              ]
            }
            that.echartBox.setOption(setDataOptin)
          } else {
            that.echartBox.hideLoading()
            const setDataOptin = {
              xAxis: [
                {
                  type: 'category',
                  axisTick: { show: false },
                  axisLabel: { interval: 0, rotate: 40 },
                  data: res.result.xAxis.data,
                  axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } }
                }
              ],
              series: [
                {
                  data: res.result.series[0].data
                },
                {
                  data: res.result.series[1].data
                }
              ]
            }
            that.echartBox.setOption(setDataOptin)
          }
        }
      })
    },
    categoryProgram () { // 节目及节目集分类统计
      // 基于准备好的dom，初始化echarts实例
      const option = {
        title: {
          text: '节目及节目集分类统计',
          left: '2%',
          textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
        },
        legend: {
          top: '5%',
          right: '3%',
          icon: 'rect',
          itemWidth: 7,
          itemHeight: 7,
          textStyle: { color: '#2C3542' },
          data: ['节目数量', '节目集数量']
        },
        grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            axisLabel: { interval: 0, rotate: 40 },
            data: [],
            axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量',
            splitLine: { lineStyle: { type: 'dashed' } }, // 网格线
            axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } },
            axisTick: { show: false, lineStyle: '#BFBFBF' },
            axisLabel: { color: '#666978' }
          }
        ],
        series: [
          {
            name: '节目数量',
            type: 'bar',
            barWidth: '25%',
            data: [],
            itemStyle: { normal: { color: '#F49722' } }
          },
          {
            name: '节目集数量',
            type: 'bar',
            barWidth: '25%',
            data: [],
            itemStyle: { normal: { color: '#33A3F0' } }
          }
        ]
      }
      const dataChart = this.$echarts.init(document.getElementById('categoryData'))
      // 绘制图表
      this.echartBox = dataChart
      this.echartBox.setOption(option)
      this.getData()
    },
    exportInputAnalysis () {
      window.location.href = process.env.VUE_APP_BASE_API_MGR + `/categoryCountExport?startTime=${this.form.startTime}&endTime=${this.form.endTime}&createBy=${this.form.createBy}&platform=${this.form.platform}`
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../../assets/css/dataAnalysis.less";
</style>
